
        import * as module0 from '$components/cookie_consent.js';import * as module1 from '$components/courses_page.js';import * as module2 from '$components/form.css';import * as module3 from '$components/hero_parallax.js';import * as module4 from '$components/main.js';import * as module5 from '$components/matomo_events.js';import * as module6 from '$components/search.css'
        const modules = {
            "cookie_consent.js": module0,
            "courses_page.js": module1,
            "form.css": module2,
            "hero_parallax.js": module3,
            "main.js": module4,
            "matomo_events.js": module5,
            "search.css": module6,
        };
        export default modules;
      